export const Kwan = () => {
  return (
    <div className="flex justify-center bg-gradient-to-br from-[#FAE7ED] via-[#52A0FC] to-[#3BE1FE]">
      <div className=" pt-[180px] pb-[100px] px-[15rem] w-[1920px]">
        <div className="h-[460px]  flex justify-between items-center gap-[20px]">
          <div className="flex flex-col justify-between  h-full py-[47px]">
            <div className="w-[547px] bg-gradient-to-r from-[#619BFF] to-[rgba(198,225,255,0)] rounded-[10px] px-[10px] py-[4px] ">
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-bold text-[25px] text-[#FFFFFF]">
                光年自建K-WAN组网解决方案
              </div>
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-bold text-[50px] text-[#333333]">
              光年K-WAN组网解决方案
            </div>
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-Regular text-[24px] text-[#333333]">
              就近接入全球骨干网络，形成快速、稳定、合规的访问全球互联网资源加速专线，为出海企业提供优质的网络加速服务
            </div>
            <div className="w-[170px] h-[60px] bg-gradient-to-br from-[#5F97FF] to-[#0182FF] rounded-[10px] flex items-center justify-center mt-[30px]">
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[25px] text-[#FFFFFF]">
                立即咨询
              </div>
            </div>
          </div>

          <div>
            <img
              className="w-[690px] min-w-[690px] h-[460px]"
              src={"/imgs/kwan/k-wan.png"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
